import { createContext, useContext, useEffect, useState } from "react";
import { useNotify } from "./ui.notify";

// ------------------ rest headers

const RestHeaderContext = createContext();
export function RestHeaderMng(props) {
    const { headers, ...rest } = props;
    return <RestHeaderContext.Provider value={{ headers }} {...rest} />
}



// ------------------ context

export const RestContext = createContext();
export function Rest(props) {
    const notify = useNotify()
    const [error, setError] = useState()

    useEffect(() => {
        if (error) {
            notify.message('Errore di comunicazione con il server', 'error')
        }
    }, [error])


    const host = props.host || window.location.hostname;
    const port = props.port || window.location.port;

    const cfg = {
        host,
        port,
    }


    return <RestContext.Provider value={{ error, setError, cfg }}>
        {props.children}
    </RestContext.Provider>
}

// ------------------ useRest

export function useRest(req, def, disableAutoStart) {
    const [loading, setLoading] = useState(false)
    const [result, setResult] = useState(def || null);
    const { cfg, setError } = useContext(RestContext)
    const additionalHeaders = useContext(RestHeaderContext)
    const headers = additionalHeaders && additionalHeaders.headers;

    function retry() {
        setLoading(true)
        doCall(cfg, { cmd: req, headers: headers },
            (response) => {
                setError(undefined)
                setResult(response)
                setLoading(false)
            }, err => {
                setError(err)
                setLoading(false)
            })
    }

    useEffect(() => {
        if (!disableAutoStart) {
            retry();
        }
    }, [req])

    return [result, retry, loading]
}



// ------------------ useRestCall

export function useRestCall(onComplete, onError) {
    const [loading, setLoading] = useState(false)
    const { cfg, setError } = useContext(RestContext)
    const additionalHeaders = useContext(RestHeaderContext)
    const headers = additionalHeaders && additionalHeaders.headers;

    function i_call(cmd, payload) {
        setLoading(true)
        doCall(cfg, {
            cmd,
            payload,
            headers
        }, (response) => {
            setLoading(false)
            setError(undefined)
            onComplete && onComplete(response)
        }, (err) => {
            setLoading(false)
            onError && onError(err)
            setError(err)
        })
    }


    return [i_call, loading]
}

// ------------------ call

function doCall(cfg, call, cb, err) {
    const host = window.location.hostname;
    const curr_port = window.location.port;
    const curr_protocol = window.location.protocol.split(":")[0];

    const bg_port = cfg.port || curr_port
    const bg_host = cfg.host || host

    // ------call

    const payload = call.payload;
    const cmd = call.cmd;
    const headers = call.headers || {};
    var url = curr_protocol + '://' + bg_host + ':' + bg_port + '/api/' + cmd;

    // ------err

    if (!err) {
        err = (msg) => {
            console.log("ERROR: " + msg)
        }
    }

    // ------payload

    var opts = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            ...headers,
        },
    }
    if (payload) {
        if (Object.prototype.toString.call(payload) === '[object File]') {
            opts = {
                method: 'POST',
                headers: {
                    'content-type': payload.type,
                    'content-length': "" + payload.size,
                    ...headers,
                },
                body: payload
            }
        } else {
            opts = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers,
                },
                body: JSON.stringify(payload)
            };
        }
    }


    // ------fetch


    console.log("----> " + url)
    fetch(url, opts)
        .then(res => {
            if (!res.ok) {
                err("" + res.status + ' ' + res.error)
            } else {
                const contentType = res.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    res.json().then((json) => {
                        console.log(json)
                        if (cb) {
                            cb(json);
                        }
                    })
                        .catch((e) => {
                            err("" + e)
                        });
                } else {
                    if (cb) {
                        cb();
                    }
                }
            }
        })
        .catch((e) => {
            err("" + e)
        });
}




